import React from 'react'
import PropTypes from 'prop-types'
import { Card, Row, Col, Descriptions, Tag, Switch } from 'antd'
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import styles from './Component.css'

export default class _SettingsPanel_ extends React.PureComponent {

  static propTypes = {
    settings: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
  }

  formatSettingValue = (key, value, definition) => {
    if (!definition) {
      return value || 'Not set'
    }

    // Handle specific boolean TBT settings with green/red tags
    if (key === 'tbt_enabled' || key === 'tbt_send_email' || key === 'tbt_send_sms' ||
        key === 'tbt_require_signature' || key === 'tbt_generate_pdf') {
      // More robust boolean detection for these specific settings
      const isEnabled = value === '1' || value === 1 || value === true || value === 'true' ||
                       value === 'Enabled' || value === 'enabled' || value === 'on'
      return isEnabled ? (
        <Tag color="green" icon={<CheckCircleOutlined />}>Enabled</Tag>
      ) : (
        <Tag color="red" icon={<CloseCircleOutlined />}>Disabled</Tag>
      )
    }

    // Handle boolean/checkbox fields (field_type_id = 5) - fallback for other boolean fields
    if (definition.field_type_id === 5) {
      const isEnabled = value === '1' || value === 1 || value === true || value === 'true' ||
                       value === 'Enabled' || value === 'enabled' || value === 'on'
      return isEnabled ? (
        <Tag color="green" icon={<CheckCircleOutlined />}>Enabled</Tag>
      ) : (
        <Tag color="red" icon={<CloseCircleOutlined />}>Disabled</Tag>
      )
    }

    // Handle dropdown/select fields with processor_json options
    if (definition.processor_json) {
      try {
        const options = JSON.parse(definition.processor_json)
        if (Array.isArray(options)) {
          const option = options.find(opt => opt.value === value)
          if (option && option.label) {
            return option.label
          }
        }
      } catch (e) {
        // If JSON parsing fails, fall through to default handling
      }
    }

    // Handle numeric fields with special formatting
    if (definition.field_type_id === 2) { // number field type
      switch (key) {
        case 'tbt_frequency_days':
          return value && value !== '0' ? `${value} day${value !== '1' ? 's' : ''} ahead` : 'Not set'
        case 'tbt_documents_per_run':
          return value && value !== '0' ? `${value} document${value !== '1' ? 's' : ''} per run` : 'Not set'
        case 'tbt_reminder_days':
          return value && value !== '0' ? `Every ${value} day${value !== '1' ? 's' : ''}` : 'No reminders'
        default:
          return value || 'Not set'
      }
    }

    // Default formatting
    return value || 'Not set'
  }

  render () {
    const { settings, loading } = this.props

    // Extract values and definitions from the new settings structure
    const settingsValues = settings.values || {}
    const settingsDefinitions = settings.definitions || {}

    const settingsConfig = [
      { key: 'tbt_enabled', label: 'Enable TBT System', span: 1 },
      { key: 'tbt_subby_booking_check', label: 'Subcontractor booked check', span: 1 },
      { key: 'tbt_send_schedule', label: 'Send Schedule', span: 1 },
      { key: 'tbt_documents_per_run', label: 'Documents Per Run', span: 1 },
      { key: 'tbt_send_email', label: 'Send Email Notifications', span: 1 },
      { key: 'tbt_send_sms', label: 'Send SMS Notifications', span: 1 },
      { key: 'tbt_reminder_days', label: 'Reminder Days', span: 1 },
      { key: 'tbt_require_signature', label: 'Require Digital Signature', span: 1 },
      { key: 'tbt_generate_pdf', label: 'Generate PDF Reports', span: 1 },
    ]

    return (
      <div className={styles.wrapper}>
        <Card
          title="TBT System Configuration"
          loading={loading}
          className={styles.settingsCard}
        >
          <Descriptions
            bordered
            column={{ xxl: 3, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }}
            size="small"
          >
            {settingsConfig.map(({ key, label, span }) => (
              <Descriptions.Item
                key={key}
                label={label}
                span={span}
              >
                {this.formatSettingValue(key, settingsValues[key], settingsDefinitions[key])}
              </Descriptions.Item>
            ))}
          </Descriptions>
        </Card>
      </div>
    )
  }
}
